import { v4 as uuidv4 } from 'uuid';
import ModalForm from "../../components/base/forms/modal-form";
import ServiceLocator from "../../global/service-locator";
import Api from "../../lib/api";
import {AnalyticsService} from "../../services/analytics-service";

export default class FormController {
	constructor() {
		this.sl = ServiceLocator.instance;
		this.init();
	}

	init() {
		const lang = document.querySelector('html').lang;

		if (craft.page.isConsultationForm !== false) {
			this.initConsultationForm();
		}
	}

	initConsultationForm() {
		const formConfig = {
			formId: 'consultation',
			uri: '/2.0/courses/registration',
			hash: 'consultation',
			data: {
				type: 'consultation',
				city: craft.env.cityId || Api.currentCityId,
				course: craft.page.courseDirectoryId ? craft.page.courseDirectoryId : null,
				fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
				fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
				referrer: location.href
			},
			$modalTriggers: Array.from(document.querySelectorAll('.btn-consultation')),
			afterOpen: () => {
				/* FB Analytics data for backend */
				if (craft.page.handle == 'courses-entry') {
					if (craft.page.coursesStatsConfig &&
						craft.page.coursesStatsConfig.entryId
					) {
						Api.sendFbEvent('AddToCart', {
							entryId: craft.page.coursesStatsConfig.entryId
						});
					} else {
						console.error('Api/fbq: entryId is not defined');
					}
				}
			},
			subscriptions: [
				{
					field: 'course',
					event: 'getEntryIdOnValueChange',
					callback: ({ detail }) => {
						/* FB Analytics */
						Api.sendFbEvent('AddToCart', {
							entryId: detail
						});
					}
				},
				{
					event: 'beforeSubmit',
					callback: () => {
						const courseLang = this.sl.courseLang;
						const conversionId = uuidv4();
						const owoxUserId = costorage.get('ouid');


						if (courseLang) {
							this.consultationForm.addData({ courseLang });
						}

						this.consultationForm.addData({ conversionId });

						if (owoxUserId) {
							this.consultationForm.addData({ owoxUserId });
						}

						const dataLayerEventData = {
							event: 'free_consultation_form',
							formId: this.consultationForm.formId,
							phone: this.consultationForm.data.tel,
							email: this.consultationForm.data.email,
							conversion_id: conversionId
						};

						const $formTitle = this.consultationForm.$root.querySelector('.form_title');

						if ($formTitle) {
							dataLayerEventData.formName = $formTitle.textContent;
						}

						AnalyticsService.sendEvent('free_consultation_form', dataLayerEventData);
					}
				},
				{
					event: 'submitComplete',
					callback: () => {
						costorage.set('h_consultationRequested', 1, {
							expires: 45 * 24 * 60 * 60,
							domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua',
							path: "/"
						});
					}
				}
			]
		};

		if (craft.page.handle === 'vpo') {
			if (!formConfig.initialValues) {
				formConfig.initialValues = {};
			}

			formConfig.initialValues.comment = craft.localization['page.vpo.hero.title'];
		}

		try	{
			this.consultationForm = new ModalForm(formConfig);
		} catch (err) {
			console.error('Consultation Form:', err);
		}
	}
}